export class Customer {
  id: number
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string

  highlighted: boolean

  constructor(
    id: number,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    email: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateId: number|undefined,
    postalCode: string) {
      this.id = id
      this.firstName = firstName
      this.lastName = lastName
      this.phoneNumber = phoneNumber
      this.email = email
      this.addressLine1 = addressLine1
      this.addressLine2 = addressLine2
      this.city = city
      this.stateId = stateId
      this.postalCode = postalCode

      this.highlighted = false
  }
}
